export default __webpack_public_path__ + "static/media/icpc-medium5-cmplay.261c0c0b.png";